<template>
  <v-layout
    column
    align-start
  >
    <!-- Wifi/cable online/offline status -->
    <v-layout
      v-if="status.online"
      align-center
    >
      <v-icon
        color="green accent-4"
        class="mr-2"
        :title="$t('online')"
        v-text="networkStatusIcon"
      />
    </v-layout>
    <v-layout
      v-if="status.offline"
      align-center
    >
      <v-icon
        color="error"
        class="mr-2"
        :title="$t('offline')"
        v-text="networkStatusIcon"
      />
    </v-layout>

    <!-- Device waiting for comissioning - no other message is displayed in this case -->
    <div v-if="status.waitingForComissioning">
      <v-layout align-center>
        <v-icon
          class="ml-1 mr-2"
          small
          color="warning"
        >
          hourglass_top
        </v-icon>
        {{ $t('deviceWaitingForComissioning') }}
      </v-layout>
    </div>

    <!-- Device is in shipping -->
    <div v-if="status.inShipping">
      <v-layout align-center>
        <v-icon
          class="ml-1 mr-2"
          small
          color="warning"
        >
          local_shipping
        </v-icon>
        <a
          :href="device.shipping_url"
          target="_blank"
        >
          {{ $t('deviceInShipping') }}
        </a>
      </v-layout>
    </div>

    <!-- Content not up-to-date warning (Player offline case) -->
    <div v-if="status.contentIsNotUpToDate">
      <v-layout align-center>
        <v-icon
          class="ml-1 mr-2"
          small
          color="warning"
        >
          video_library
        </v-icon>
        {{ $t('contentIsNotUpToDate') }}
      </v-layout>
    </div>
    <!-- Content not up-to-date warning (Player online case) -->
    <div v-if="status.inShipping">
      <v-layout align-center>
        <v-icon
          class="ml-1 mr-2"
          small
          color="warning"
        >
          refresh
        </v-icon>
        {{ $t('contentIsSyncing') }}
      </v-layout>
    </div>
  </v-layout>
</template>

<script>
import {getDeviceStatusObject} from '@/mixins/deviceStatus.js';

export default {
  props: {
    device: {
      type: Object,
      required: true,
    },
  },
  computed: {
    status() {
      return getDeviceStatusObject(this.device);
    },
    networkStatusIcon() {
      if (this.device.lte_connected) {
        return 'cell_tower';
      } else {
        return this.device.isWifi ? 'wifi' : 'power';
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Device/DeviceStatus.vue